import React from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/manrope/400.css';
import '@fontsource/manrope/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';
import '@fontsource/lora/600.css';
import '@/styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';
import '@aws-amplify/ui-react/styles.css';

import App from './App';
import { installAuthStorageMirror, hydrateAuthFromPreferences } from '@/lib/authStorage';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

// Install the localStorage→Preferences mirror first so any writes during
// hydrate are persisted both places. Then restore tokens if WKWebView lost
// them. On web both calls are no-ops and resolve immediately.
installAuthStorageMirror();
createRoot(container).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// Never block initial render on plugin I/O; slow Android startup can miss
// deep-link handling if mount waits on hydration.
void hydrateAuthFromPreferences();
